"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireWildcard(require("@pds-react/icon"));

var _excluded = ["variant", "as", "className", "iconLeft", "children", "disabled"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** Buttons help communicate actions a user can take within a page or application. */
var Button = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var variant = props.variant,
      as = props.as,
      className = props.className,
      iconLeft = props.iconLeft,
      children = props.children,
      disabled = props.disabled,
      otherProps = _objectWithoutProperties(props, _excluded);

  var classes = (0, _classnames["default"])(className, "pds-button", {
    "pds-button-icon-left": iconLeft
  }, _defineProperty({}, "pds-button-".concat(variant), !disabled));
  var Component = as;
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: classes,
    ref: ref,
    disabled: disabled
  }, otherProps), iconLeft && /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    name: iconLeft
  }), children);
});

Button.propTypes = {
  /** Controls size and colors of the Button */
  variant: _propTypes["default"].oneOf(["primary", "primary-light", "secondary", "secondary-ghost", "tertiary", "tertiary-light", "tertiary-border", "tertiary-ghost"]),

  /**
   * Adds an optional icon left side of a button.
   * It takes the "name" prop from the Icon component.
   */
  iconLeft: _icon.IconNamePropType,

  /** Changes the HTML element of the Button, for example "a" for a link styled as a button. */
  as: _propTypes["default"].elementType,

  /** Extra classes for the Button. */
  className: _propTypes["default"].string,

  /** The content of the Button. */
  children: _propTypes["default"].node.isRequired,

  /** State of Button. */
  disabled: _propTypes["default"].bool
};
Button.defaultProps = {
  variant: "primary",
  as: "button"
};
Button.displayName = "Button";
var _default = Button;
exports["default"] = _default;